export const academyLogger = {
  debug: () => {},
  error: () => {},
  info: () => {},
  warn: () => {},
};
